var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1795,
    height: 585,
    viewBox: "0 0 1795 585",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92188 357.609L75.042 399.196L245.288 300.429L170.564 258.842L2.92188 357.609Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 459.221L75.4521 500.808L245.698 402.041L170.975 360.466L3.33203 459.221Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.043 399.195V500.808",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M243.918 299.496V401.12",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92188 356.883V461.134",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.043 398.262L147.175 439.849L317.409 341.082L242.686 299.495L75.043 398.262Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4531 499.887L147.585 541.462L317.819 442.707L243.096 401.12L75.4531 499.887Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.172 439.849V541.461",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M316.039 340.149V441.774",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.043 397.548V501.787",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92188 255.997L75.042 297.571L245.288 198.816L170.564 157.229L2.92188 255.997Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 357.609L75.4521 399.196L245.698 300.429L170.975 258.842L3.33203 357.609Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M75.043 297.571V399.196",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M243.918 197.884V299.496",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92188 255.271V359.522",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4492 296.651L147.581 338.238L317.815 239.471L243.092 197.884L75.4492 296.651Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8594 398.263L147.979 439.85L318.225 341.083L243.502 299.496L75.8594 398.263Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M147.578 338.237V439.85",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M316.445 238.538V340.15",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4492 295.925V400.176",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M147.66 439.801L219.792 481.388L390.026 382.621L315.303 341.034L147.66 439.801Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M148.07 541.414L220.202 583L390.436 484.233L315.713 442.646L148.07 541.414Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M219.789 481.388V583",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M388.656 381.688V483.301",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M147.66 439.075V543.327",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M148.066 338.177L220.199 379.764L390.432 280.997L315.709 239.41L148.066 338.177Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M148.477 439.802L220.609 481.377L390.842 382.622L316.119 341.035L148.477 439.802Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M220.195 379.764V481.388",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M389.062 280.076V381.688",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M148.066 337.463V441.714",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92188 154.723L75.042 196.31L245.288 97.5428L170.564 55.9561L2.92188 154.723Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 256.336L75.4521 297.923L245.698 199.156L170.975 157.581L3.33203 256.336Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M75.043 196.31V297.922",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M243.918 96.6104V198.235",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92188 153.997V258.249",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4492 195.377L147.581 236.964L317.815 138.197L243.092 96.6104L75.4492 195.377Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8594 296.989L147.979 338.576L318.225 239.821L243.502 198.234L75.8594 296.989Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M147.578 236.964V338.576",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M316.445 137.265V238.889",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4492 194.651V298.903",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M148.066 236.916L220.199 278.49L390.432 179.735L315.709 138.148L148.066 236.916Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M148.477 338.528L220.609 380.115L390.842 281.348L316.119 239.761L148.477 338.528Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M220.195 278.49V380.115",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M389.062 178.803V280.415",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M148.066 236.188V340.44",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.39 357.608L1195.52 399.195L1365.76 300.428L1291.03 258.841L1123.39 357.608Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.8 459.22L1195.92 500.807L1366.17 402.04L1291.44 360.465L1123.8 459.22Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.52 399.194V500.807",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.39 299.495V401.119",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.39 356.882V461.133",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.52 398.262L1267.64 439.849L1437.88 341.082L1363.15 299.495L1195.52 398.262Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.92 499.887L1268.05 541.462L1438.29 442.707L1363.56 401.12L1195.92 499.887Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1267.64 439.849V541.461",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1436.51 340.149V441.774",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.52 397.548V501.787",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.39 255.996L1195.52 297.57L1365.76 198.815L1291.03 157.229L1123.39 255.996Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.8 357.608L1195.92 399.195L1366.17 300.428L1291.44 258.841L1123.8 357.608Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.52 297.57V399.195",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.39 197.883V299.495",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.39 255.27V359.521",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.92 296.65L1268.05 338.237L1438.29 239.47L1363.56 197.883L1195.92 296.65Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.33 398.262L1268.46 439.849L1438.7 341.082L1363.97 299.495L1196.33 398.262Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1268.05 338.236V439.849",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1436.92 238.537V340.149",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.92 295.923V400.174",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1693.5 101.767L1621.38 143.354L1451.13 44.5868L1525.86 3L1693.5 101.767Z",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1693.09 203.379L1620.97 244.966L1450.72 146.199L1525.45 104.612L1693.09 203.379Z",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1621.38 143.354V244.966",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1452.5 43.6543V145.279",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1693.5 101.041V205.293",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1547.71 304.653L1619.83 346.24L1790.08 247.473L1715.35 205.886L1547.71 304.653Z",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1548.12 406.265L1620.24 447.852L1790.49 349.085L1715.76 307.498L1548.12 406.265Z",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1619.83 346.239V447.852",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1788.71 246.54V348.164",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1547.71 303.927V408.178",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.39 154.723L1195.52 196.31L1365.76 97.5428L1291.03 55.9561L1123.39 154.723Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.8 256.336L1195.92 297.923L1366.17 199.156L1291.44 157.581L1123.8 256.336Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.52 196.31V297.922",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.39 96.6104V198.235",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.39 153.997V258.249",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1282.76 144.566L1354.88 186.152L1525.13 87.3852L1450.4 45.8105L1282.76 144.566Z",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1283.17 246.19L1355.29 287.777L1525.54 189.01L1450.81 147.423L1283.17 246.19Z",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1354.88 186.152V287.777",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1523.76 86.4648V188.077",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1282.76 143.851V248.102",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1547.71 203.378L1619.83 244.965L1790.08 146.198L1715.35 104.611L1547.71 203.378Z",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1548.12 305.003L1620.24 346.578L1790.49 247.823L1715.76 206.236L1548.12 305.003Z",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1619.83 244.965V346.577",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1788.71 145.266V246.89",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1547.71 202.664V306.903",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M528.891 357.608L601.011 399.195L771.256 300.428L696.533 258.841L528.891 357.608Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M529.301 459.22L601.421 500.807L771.667 402.04L696.943 360.465L529.301 459.22Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M601.012 399.194V500.807",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M769.879 299.495V401.119",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M528.891 356.882V461.133",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M601.008 398.262L673.14 439.849L843.374 341.082L768.651 299.495L601.008 398.262Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M601.418 499.887L673.538 541.462L843.784 442.707L769.061 401.12L601.418 499.887Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M673.137 439.849V541.461",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M842.004 340.149V441.774",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M601.008 397.548V501.787",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M528.891 255.996L601.011 297.57L771.256 198.815L696.533 157.229L528.891 255.996Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M529.301 357.608L601.421 399.195L771.667 300.428L696.943 258.841L529.301 357.608Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M601.012 297.57V399.195",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M769.879 197.883V299.495",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M528.891 255.27V359.521",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M674.449 254.433L746.581 296.02L916.815 197.253L842.092 155.666L674.449 254.433Z",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M674.859 356.045L746.98 397.632L917.225 298.865L842.502 257.278L674.859 356.045Z",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M746.578 296.02V397.632",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M915.445 196.32V297.945",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M674.449 253.707V357.959",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M673.621 439.801L745.753 481.388L915.987 382.621L841.264 341.034L673.621 439.801Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M674.031 541.414L746.163 583L916.397 484.233L841.674 442.646L674.031 541.414Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M745.75 481.388V583",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M914.617 381.688V483.301",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M673.621 439.075V543.327",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M747.066 295.961L819.199 337.547L989.432 238.78L914.709 197.193L747.066 295.961Z",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M747.477 397.586L819.609 439.16L989.842 340.405L915.119 298.818L747.477 397.586Z",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M819.195 337.547V439.171",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M988.062 237.859V339.472",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M747.066 295.246V399.498",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M528.891 154.723L601.011 196.31L771.256 97.5428L696.533 55.9561L528.891 154.723Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M529.301 256.336L601.421 297.923L771.667 199.156L696.943 157.581L529.301 256.336Z",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M601.012 196.31V297.922",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M769.879 96.6104V198.235",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M528.891 153.997V258.249",
    stroke: "white",
    strokeWidth: 2.26397,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M674.449 153.161L746.581 194.748L916.815 95.9804L842.092 54.3936L674.449 153.161Z",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M674.859 254.774L746.98 296.36L917.225 197.605L842.502 156.019L674.859 254.774Z",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M746.578 194.747V296.359",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M915.445 95.0479V196.672",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M674.449 152.435V256.686",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M747.066 194.698L819.199 236.273L989.432 137.518L914.709 95.9307L747.066 194.698Z",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M747.477 296.31L819.609 337.897L989.842 239.13L915.119 197.543L747.477 296.31Z",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M819.195 236.272V337.897",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M988.062 136.585V238.197",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M747.066 193.972V298.223",
    stroke: "#26483E",
    strokeWidth: 3.9347,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopLg);
export default __webpack_public_path__ + "static/media/desktop-lg.2c401af87b96b481115c6dd2c597c5dd.svg";
export { ForwardRef as ReactComponent };